import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Use concurrent features for better TTI
const root = createRoot(document.getElementById("root")!);
root.render(<App />);
